<template>
	<div>
		<div v-if="!thirdPersonAssuranceAuthorizationItem || !thirdPersonAssuranceAuthorizationItem.user">
			<div class="red--text text-ecnter mb-2">ضامن تعیین نشده است.</div>
			<div class="text-center">
				<v-btn small outlined color="primary" @click="selectMemberDialog = true">
					انتخاب ضامن
				</v-btn>
			</div>
		</div>
		<div v-if="thirdPersonAssuranceAuthorizationItem && thirdPersonAssuranceAuthorizationItem.user">
			<v-row>
				<v-col cols="12" md="2">
					<img class="" style="border-radius: 50%;height: 50px;" :src="require('@/assets/dummy-profile-grey.png')">
					</img>
				</v-col>
				<v-col cols="12" md="8" class="pr-0">
					<div class="text-right">{{ thirdPersonAssuranceAuthorizationItem.user.fullName }}</div>
					<div class="text-right">
						<small class="grey--text">کد ملی:</small>
						<small class="grey--text">{{ thirdPersonAssuranceAuthorizationItem.user.nationalCode }}</small>
					</div>
				</v-col>
				<v-col cols="12" md="2" class="d-flex flex-column align-center">
					<v-btn small outlined color="primary" @click="selectMemberDialog = true" class="mb-2">
						تغییر ضامن
					</v-btn>
					<v-btn small outlined color="primary" @click="contractDialog = true">
						مشاهده قرارداد
					</v-btn>
				</v-col>
			</v-row>
			<div class="mt-2 text-justify contract" v-if="thirdPersonAssuranceAuthorizationItem.tag" v-html="thirdPersonAssuranceAuthorizationItem.tag">

			</div>
		</div>
		<div v-if="auth.memberDescription === 'signed'" class="d-flex px-2 align-center" style="width:170px">
			<v-text-field v-model="mobileOtp" maxlength="5" label="کد تایید" :rules="[() => !!mobileOtp || 'الزامی']" required />
			<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP" :loading="optLoading"><small>ارسال
					کد</small></v-btn>
			<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
		</div>

		<v-dialog v-model="contractDialog" max-width="1600px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">اطلاعات قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="contractDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<ThirdPersonContractDetail v-if="contractDialog" :area="area" :thirdPersonAssuranceAuthorizationItem="thirdPersonAssuranceAuthorizationItem" :mobile="mobile" @updated="$emit('updated')" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="selectMemberDialog" max-width="750px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">انتخاب ضامن</span>
					</div>
					<v-spacer />
					<v-btn @click="selectMemberDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-row class="justify-center">
						<v-col cols="12" md="6">
							<v-form @submit.prevent="searchMember">
								<div class="mt-4">
									<div>
										<strong class="red--text">کد ملی</strong>
										شخص مورد نظر را وارد نمایید:
									</div>
								</div>
								<v-text-field class="mb-4" compact ref="nationalCode" v-model="searchPhrase" maxlength="10" label="" :error-messages="errorMessages" :rules="[() => !!searchPhrase || 'اطلاعات را وارد کنید']" required />
								<v-alert class="mb-2 mt-2" type="error" outlined v-if="searchMessage">
									{{ searchMessage }}
								</v-alert>
								<v-btn color="primary" type="submit" :loading="searchLoading" block>
									جستجوی شخص
								</v-btn>
							</v-form>
						</v-col>
					</v-row>
					<div v-if="members !== null" style="padding: 10px;margin-top: 25px;">
						<v-alert v-if="!members.length" outlined type="error" icon="mdi-closews">
							<div class="text-center mb-2">
								شخصی با مشخصات وارد شده یافت نشد.
							</div>
							<div class="text-center">
								<v-btn color="primary" class="" :loading="!!selectedMemberId" @click="modifyThirdPersonDialog = true">ثبت مشخصات ضامن</v-btn>
							</div>
						</v-alert>
						<v-row v-for="(member, index) in members" :key="index" style="border-bottom: 1px dashed #eee;" class="justify-center">
							<v-col cols="12" sm="6">
								<v-card color="#fff" class="pa-2">
									<div class="mb-1 text-center">
										<img class="" style="border-radius: 50%;height: 70px;" :src="require('@/assets/dummy-profile-grey.png')">
										</img>
									</div>
									<div class="text-center secondary--text" style="font-size: 14px;">
										{{ member.fullName }}
									</div>
									<div class="text-center grey--text mb-2">
										کد ملی: {{ member.nationalCode }}
									</div>
									<div class="d-flex flex-wrap justify-center">
										<v-btn small color="info" class="mx-1 mb-1" @click="selectMember(member)" :loading="selectedMemberId === member.id">انتخاب</v-btn>
									</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="manualDialog" max-width="500px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">اطلاعات دستی قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="manualDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div v-if="manualFields.length" class="mt-5">
						<v-text-field v-for="(field, index) in manualFields" :key="field.id || index" v-model="field.value" :label="field.label" dense outlined />
					</div>
					<div v-else class="text-center grey--text">
						موردی برای نمایش وجود ندارد.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="manualDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" :loading="submitManualTagsLoading" @click="submitManualTags">به روز رسانی
						متن قرارداد</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyThirdPersonDialog" max-width="500px" scrollable>
			<ModifyThirdPersonAssurance v-if="modifyThirdPersonDialog" :area="area" @callbck="modifyThirdPersonAssuranceCallbck" @close="modifyThirdPersonDialog = false" />
		</v-dialog>

		<v-dialog v-model="sendSmsLinkAlertDialog" max-width="450px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">توجه</span>
					</div>
					<v-spacer />
					<v-btn @click="sendSmsLinkAlertDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div class="text-justify red--text">
						کاربر گرامی، پیامک حاوی لینک امضای قرارداد برای ضامن ارسال شد.
						در صورت ارسال نشدن پیامک، ضامن می تواند با مراجعه به پنل کاربری خود در این سایت و ورود با کدملی
						به عنوان نام کاربری و کلمه عبور
						اقدام به امضای قرارداد نماید.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn color="primary" @click="sendSmsLinkAlertDialog = false">
						متوجه شدم
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'
	import { auth } from '@/store/modules'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'DigitalSignSms',
		props: {
			auth: { type: Object, default: null },
			thirdPersonAssuranceAuthorizationItem: { type: Object, default: null },
			area: { type: String, default: 'member' },
		},
		data() {
			return {
				modifyThirdPersonDialog: false,
				selectedMemberId: null,
				members: null,
				searchLoading: false,
				searchMessage: '',
				mobileOtp: '',
				sendCodeVisible: true,
				errorMessages: '',
				searchPhrase: '',
				optLoading: false,
				submitManualTagsLoading: false,
				manualDialog: false,
				selectMemberDialog: false,
				contractDialog: false,
				manualFields: [],
				sendSmsLinkAlertDialog: false
			}
		},
		components: {
			Countdown: () => import('@/components/Countdown'),
			ThirdPersonContractDetail: () => import('@/components/loanAuthorizations/ThirdPersonContractDetail'),
			ModifyThirdPersonAssurance: () => import('@/components/forms/ModifyThirdPersonAssurance')
		},
		computed: {
			member() {
				return this.thirdPersonAssuranceAuthorizationItem?.user
			},
			mobile() {
				return this.member?.mobile || ''
			}
		},
		mounted() {

		},
		methods: {
			searchMember() {
				this.searchMessage = ''
				if (!this.searchPhrase) {
					this.searchMessage = 'ابتدا عبارت مورد نظر جهت جستجو را وارد کنید'
					return
				}
				this.searchLoading = true
				api.get(`${this.area}/member/GetByNationalCode/` + this.searchPhrase, null)
					.then(response => {
						this.members = !response || response?.id === 0 ? [] : [response]
					})
					.catch(err => {
						this.searchMessage = err.message
					})
					.finally(() => this.searchLoading = false)
			},
			extractManualFields(description) {
				const fields = []
				if (!description) {
					this.manualFields = fields
					return
				}
				const regex = /\{manual:"([^"]+)"\}/g
				const prevFields = this.manualFields || []
				let match
				while ((match = regex.exec(description)) !== null) {
					const label = match[1]
					const index = fields.length
					fields.push({
						id: `${match.index}-${label}-${index}`,
						label,
						value: prevFields[index]?.value || ''
					})
				}
				this.manualFields = fields
			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.localData.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendOTP/' + this.localData.mobile, {})
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
			submitManualTags() {
				this.submitManualTagsLoading = true
				const manualFieldsObj = this.manualFields.reduce((acc, field) => {
					acc[field.label] = field.value
					return acc
				}, {})
				api.post('admin/ThirdPersonAssuranceAuthorizationItem/UpdateDigitalSignDescription/', { manualFields: manualFieldsObj, thirdPersonAssuranceAuthorizationItemId: this.thirdPersonAssuranceAuthorizationItem.id })
					.then(response => {
						this.manualDialog = false
						toast.success('اطلاعات قرارداد با موفقیت ثبت شد.')
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.submitManualTagsLoading = false
					})
			},
			selectMember(member) {
				this.selectedMemberId = member.id
				let action = this.thirdPersonAssuranceAuthorizationItem ? 'edit' : 'create'
				let data = {
					userLoanRequestAuthorizationItemId: this.auth.id,
					userLoanId: this.userLoanId,
					user: member,
					authorizationItemId: this.auth.authorizationItem.id
				}
				api.post(`${this.area}/ThirdPersonAssuranceAuthorizationItem/${action}`, data)
					.then(response => {
						this.selectMemberDialog = false
						this.sendSmsLinkAlertDialog = true
						//toast.success('ضامن.')
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.selectedMemberId = ''
					})
			},
			modifyThirdPersonAssuranceCallbck(data) {
				this.modifyThirdPersonDialog = false
				if (data)
					this.selectMember({ id: data })
			}
		}
	}
</script>
<style scoped>
	.contract b {
		font-weight: 900;
		border-bottom: 1px dotted blue;
		color: blue;
	}
</style>
